import React from 'react';
import PropTypes from 'prop-types';
import { Container } from './styles';

export default function ColButton({ children, ...props }) {
  return <Container {...props}>{children}</Container>;
}

ColButton.propTypes = {
  children: PropTypes.any.isRequired,
};
